"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.tabTemplates = void 0;
const templateNames_1 = require("../templateNames");
exports.tabTemplates = [
    {
        id: "non-sso-tab-ts",
        name: templateNames_1.TemplateNames.Tab,
        language: "typescript",
        description: "Simple Teams Tab App",
    },
    {
        id: "non-sso-tab-js",
        name: templateNames_1.TemplateNames.Tab,
        language: "javascript",
        description: "Simple Teams Tab App",
    },
    {
        id: "sso-tab-with-obo-flow-ts",
        name: templateNames_1.TemplateNames.SsoTabObo,
        language: "typescript",
        description: "Simple Teams Tab App with OBO Flow",
    },
    {
        id: "sso-tab-with-obo-flow-js",
        name: templateNames_1.TemplateNames.SsoTabObo,
        language: "javascript",
        description: "Simple Teams Tab App with OBO Flow",
    },
    {
        id: "dashboard-tab-ts",
        name: templateNames_1.TemplateNames.DashboardTab,
        language: "typescript",
        description: "Dashboard Tab App",
        link: "https://aka.ms/teamsfx-dashboard-app",
    },
    {
        id: "dashboard-tab-js",
        name: templateNames_1.TemplateNames.DashboardTab,
        language: "javascript",
        description: "Dashboard Tab App",
        link: "https://aka.ms/teamsfx-dashboard-app",
    },
    {
        id: "spfx-tab-ts",
        name: templateNames_1.TemplateNames.TabSPFx,
        language: "typescript",
        description: "SPFx App",
    },
];
//# sourceMappingURL=tab.js.map